import React from 'react';
import {
  ReceiptLong as ReceiptLongIcon,
  AddTask as AddTaskIcon,
  Dashboard as DashboardIcon,
  RequestQuote as DepartmentIcon,
} from '@mui/icons-material';
import AddCommentIcon from '@mui/icons-material/AddComment';

import MenuBookIcon from '@mui/icons-material/MenuBook';
import RuleIcon from '@mui/icons-material/Rule';
//  The routine library. A bookmark rather than a book: MenuBook is already Templates,
//  and two identical icons in one sidebar is a menu nobody can scan.
import LibraryIcon from '@mui/icons-material/CollectionsBookmark';
//  A condition template pairs a diagnosis with what to give for it. A checklist rather
//  than a book: the three above are already books and bookmarks.
import ConditionIcon from '@mui/icons-material/FactCheck';

import DepartmentLayout from '../Layout/DepartmentLayout';
import Home from './Home';
import HospitalClaims from './HospitalClaims';
import ClaimsReport from './ClaimsReport';
import OutPatient from './OutPatient';
import Templates from './Templates';   // index.js — licence gate around the ported department
import ClaimRules from './ClaimRules';
import ClaimRoutines from './ClaimRoutines';
import ConditionTemplates from './ConditionTemplates';

const MENU_ITEMS = [
  { key: 'Home',           label: 'Home',          icon: <ReceiptLongIcon />, component: Home },
  { key: 'HospitalClaims', label: 'Claims',        icon: <AddTaskIcon />,      component: HospitalClaims },
  { key: 'ClaimsReport',   label: 'Claims Report', icon: <DashboardIcon />,    component: ClaimsReport },
  { key: 'OutPatient',     label: 'Documentation', icon: <AddCommentIcon />,   component: OutPatient },

  // Clinical Templates — a licensed add-on, sitting with Claims because it is
  // the insurance-side documentation library the auditors here build and use.
  //
  // It is NOT hidden from this list when unlicensed. DepartmentLayout filters
  // menu items by component permissions, which is a different question from
  // "has this facility bought Templates" — conflating them would mean a
  // permission grant could hand out a paid feature. Instead the screen itself
  // asks the licence endpoint and renders a locked state, and every route
  // behind it is gated server-side regardless of what the menu shows.
  { key: 'Templates',      label: 'Templates',     icon: <MenuBookIcon />,     component: Templates },

  // Claim Rules — where the validation the other screens enforce is DEFINED:
  // how long a membership number or CCC must be for each scheme, and which
  // characters it may contain. Last in the list because it is a settings screen
  // rather than daily work, and it has to be registered in
  // department_components (migration 049) before a role can be granted it.
  { key: 'ClaimRules',     label: 'Claim Rules',   icon: <RuleIcon />,         component: ClaimRules },

  // Claim Routines — the library of treatment routines Multi Vet has saved. A basket
  // that has been applied to a group of claims IS a standard, and one can be promoted
  // to premium; until now they had nowhere to be looked at, compared or thrown away.
  //
  // After Claim Rules for the same reason Claim Rules is last: this is a library and a
  // settings screen rather than daily work — the daily use of a routine is inside Multi
  // Vet, where there are claims to apply it to.
  //
  // NOTE: DepartmentLayout filters this menu by department_components. A role with
  // explicit component grants will not see this entry until 'ClaimRoutines' is
  // registered for department 30 the way migration 049 registered ClaimRules.
  { key: 'ClaimRoutines',  label: 'Claim Routines', icon: <LibraryIcon />,     component: ClaimRoutines },

  // Condition Templates — "for THIS condition, in THIS kind of patient, give THIS",
  // authored up front out of the facility's own priced catalogues.
  //
  // NOT part of Templates above. That is Clinical Templates, a licensed add-on whose
  // licence check reports "License server unreachable" on this install and renders a
  // locked panel — anything put there would be invisible. These are built from the
  // claims catalogues rather than being clinical narrative, so they belong here beside
  // the routines they will become once applied.
  //
  // NOTE: DepartmentLayout filters this menu by department_components. A role with
  // explicit component grants will not see this entry until 'ConditionTemplates' is
  // registered for department 30 — see migration 057.
  { key: 'ConditionTemplates', label: 'Condition Templates',
    icon: <ConditionIcon />, component: ConditionTemplates },
];

export default function Claims() {
  return (
    <DepartmentLayout
      departmentId={30}
      departmentName="Hospital Claims"
      departmentIcon={<DepartmentIcon />}
      menuItems={MENU_ITEMS}
    />
  );
}
